/**
 * Canonical legal document versions — keep in sync with backend/config/legal_versions.py
 */
export const CURRENT_TOS_VERSION = '2.5.0'
export const CURRENT_PRIVACY_VERSION = '1.6.0'
export const CURRENT_PARTNER_TERMS_VERSION = '1.2.2'
export const CURRENT_CLIENT_WAIVER_VERSION = '1.2.1'
export const CURRENT_GENETIC_CONSENT_VERSION = '1.1.0'
export const CURRENT_DNA_KIT_TERMS_VERSION = '1.0.0'

export const TOS_LAST_UPDATED = 'September 4, 2026'
export const PRIVACY_LAST_UPDATED = 'September 21, 2026'
export const DNA_KIT_TERMS_LAST_UPDATED = 'July 15, 2026'

export const LEGAL_ENTITY_US = 'Livewello LLC'
export const LEGAL_ENTITY_US_ADDRESS = '1240 Winnowing Way, Mt Pleasant, SC 29466'
